// extracted by mini-css-extract-plugin
export default {"btn":"ChoiceButton_btn__HToyI"};